import { IBrowserMicrofrontend } from '@cian/mf-registry/browser/microfrontend/types';
import { IAPIParameters } from '@cian/mf-registry/browser';
import { EPaymentCheckType, TMicrofrontendsAPI } from '../../../shared/types/microfrontends/buyPackage';

export const createMicrofrontendAPI = (microfrontend: IBrowserMicrofrontend): TMicrofrontendsAPI => {
  return {
    buyPackage: async parameters => {
      const payPackageMicrofrontend = microfrontend.getChild('pay-package-frontend');

      return payPackageMicrofrontend.getAPIRuntime().call('/v1/buy-package/', parameters as unknown as IAPIParameters);
    },
    setOffer: async parameters => {
      const servicePickerWidget = microfrontend.getChild('service-picker-widget-frontend');

      return servicePickerWidget.getAPIRuntime().call('/v1/set-offer', parameters as unknown as IAPIParameters);
    },
    setUser: async parameters => {
      const servicePickerWidget = microfrontend.getChild('service-picker-widget-frontend');

      return servicePickerWidget.getAPIRuntime().call('/v1/set-user', parameters as unknown as IAPIParameters);
    },
    loadPublishTerms: async () => {
      const servicePickerWidget = microfrontend.getChild('service-picker-widget-frontend');

      return servicePickerWidget.getAPIRuntime().call('/v1/reload-publish-terms', {});
    },
    getServices: async () => {
      const servicePickerWidget = microfrontend.getChild('service-picker-widget-frontend');

      return servicePickerWidget.getAPIRuntime().call('/v1/get-services', {});
    },
    checkPaymentStatus: async (paymentToken: string, type: EPaymentCheckType = EPaymentCheckType.Package) => {
      const servicePickerWidgetMicrofrontend = await microfrontend.getChild('service-picker-widget-frontend').ensure();

      return servicePickerWidgetMicrofrontend.getAPIRuntime().call('/v1/check-payment-status', { paymentToken, type });
    },
  };
};
